
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/third-cond-explanation';
const mainimage = '/Images/thirdcondprod1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "grammar", subtype: "third-cond-prod" },
];

const ThirdCondProd = () => (
  <GrammarPageLayout
    level="B2"
    title="Third Cond Prod"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Third Conditional Grammar Practice"
    seoDescription="Advanced third conditional production exercises. C1 level."
    relatedCategory="grammar-exercises"
    relatedLevel="C1"
  />
);




export default ThirdCondProd;

